import React, { useContext } from 'react';
import { Navigate, RouteProps } from 'react-router-dom';

import { Context } from 'components/hoc/Store';

// Privatni cesta pro kontrolu prihlaseni (token)
const PrivateRoute: React.FC<RouteProps> = ({ element }) => {
    const { token } = useContext(Context);
    return <>{token ? element : <Navigate to={'/prihlaseni-rozcestnik'} />}</>;
};

export default PrivateRoute;
